/* eslint-disable react/react-in-jsx-scope */
import { Checkbox, Linkedin, Mail, Signal, Whatsapp } from '@saleshandy/icons';
import { ReactNode } from 'react';
import { isMultichannelActive } from '../../../shared/utils/user-details';
import { StepType } from '../enums';

type StepTypes = {
  label: StepType;
  icon: ReactNode;
  bgColor: string;
  isHide?: boolean;
  customClassName?: string;
  customTextClass?: string;
};

export const stepBgColor = {
  [StepType.Email]: '#3B82F6',
  [StepType.WriteWithAi]: '#FFF',
  [StepType.LinkedIn]: '#178ACF',
  [StepType.Call]: '#8B5CF6',
  [StepType.WhatsApp]: '#25D366',
  [StepType.Task]: '#F97316',
  [StepType.LinkedInAutomation]: '#4F46E5',
};

export const getStepTypeArray = (
  usedThemeColor = false,
  iconColor = '#FFFFFF',
  iconWidth = 18,
  iconHeight = 18,
): StepTypes[] => [
  {
    label: StepType.Email,
    icon: (
      <Mail
        width={iconWidth}
        height={iconHeight}
        color={usedThemeColor ? stepBgColor[StepType.Email] : iconColor}
      />
    ),
    bgColor: stepBgColor[StepType.Email],
    isHide: false,
  },
  {
    label: StepType.LinkedInAutomation,
    icon: (
      <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" stroke={usedThemeColor ? '#4F46E5' : iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
    bgColor: stepBgColor[StepType.LinkedInAutomation],
    isHide: false,
  },
  {
    label: StepType.LinkedIn,
    icon: (
      <Linkedin
        width={iconWidth}
        height={iconHeight}
        color={usedThemeColor ? stepBgColor[StepType.LinkedIn] : iconColor}
      />
    ),
    bgColor: stepBgColor[StepType.LinkedIn],
    isHide: !isMultichannelActive(),
  },
  {
    label: StepType.Call,
    icon: (
      <Signal
        width={iconWidth}
        height={iconHeight}
        color={usedThemeColor ? stepBgColor[StepType.Call] : iconColor}
      />
    ),
    bgColor: stepBgColor[StepType.Call],
    isHide: !isMultichannelActive(),
  },
  {
    label: StepType.WhatsApp,
    icon: (
      <Whatsapp
        width={iconWidth}
        height={iconHeight}
        color={usedThemeColor ? stepBgColor[StepType.WhatsApp] : iconColor}
      />
    ),
    bgColor: stepBgColor[StepType.WhatsApp],
    isHide: !isMultichannelActive(),
  },
  {
    label: StepType.Task,
    icon: (
      <Checkbox
        width={iconWidth}
        height={iconHeight}
        color={usedThemeColor ? stepBgColor[StepType.Task] : iconColor}
      />
    ),
    bgColor: stepBgColor[StepType.Task],
    isHide: !isMultichannelActive(),
  },
];
